// 直播接口
import { get, post } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList // homeClient客户端 testwikidatacenter服务端

export default axios => ({
  liveRotation: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/liveroom/index/advertisement-v1`, params), // 轮播图
  liveList: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/liveroom/index/init-v1`, params), // 列表初始化
  liveListpaging: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/liveroom/index/page-v1`, params), // 列表分页
  liveDetails: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/liveroom/detail/init-v1`, params), // 详情页初始化
  liveDetailscl: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/liveroom/detail/init-v1`, params), // 详情页客户端获取
  liveisDetails: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/liveroom/detail/status-v1`, params), // 获取直播相关状态
  livereport: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/liveroom/detail/report/add-v1`, params), // 举报
  livemakean: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/liveroom/sub-v1`, params), // 预约直播
  liveAudience: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/liveroom/detail/clientonlinecount-v1`, params), // 在线观众
  liveToken: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/liveroom/detail/token-v1`, params), // im获取token
  liveJoin: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/liveroom/detail/join-v1`, params), // im加入聊天室
  liveusers: (params = {}) => post(axios, `${homeClient}/wikifxweb-v1/liveroom/detail/users-v1`, params), // im获取users
  liveEndlive: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/liveroom/detail/viewnum-v1`, params), // 结束直播人数获取
  livelike: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/liveroom/detail/like-v1`, params) // 猜你喜欢
})
